<!-- Copyright (c) 2019-2021 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details. -->
<script>
import {
  extend,
  isEmpty,
  isUndefined,
} from 'lodash';
import axios from 'axios';

//const idmContext = process.env.VUE_APP_IDM_URL;
//const amContext = process.env.VUE_APP_AM_URL;

let idmContext;
let amContext;
let realm;
const locationUrl = window.location.origin;
if (locationUrl.indexOf('dev.account.ct.gov') > 0) {
    amContext = 'https://dev.login.ct.gov/openam';
    idmContext = 'https://dev.account.ct.gov/openidm';
    realm = 'BOSCitizens';
  } else if (locationUrl.indexOf('devc.account.ct.gov') > 0) {
    amContext = 'https://devc.login.ct.gov';
    realm = 'boscitizens';
    idmContext = 'https://devc.account.ct.gov/openidm';
  } else if (locationUrl.indexOf('stg.account.ct.gov') > 0) {
    amContext = 'https://stg.login.ct.gov';
    realm = 'boscitizens';
    idmContext = 'https://stg.account.ct.gov/openidm';
  } else if (locationUrl.indexOf('psup.account.ct.gov') > 0) {
    amContext = 'https://psup.login.ct.gov';
    realm = 'boscitizens';
    idmContext = 'https://psup.account.ct.gov/openidm';
  } else if (locationUrl.indexOf('account.ct.gov') > 0) {
    amContext = 'https://login.ct.gov';
    realm = 'boscitizens';
    idmContext = 'https://account.ct.gov/openidm';
  }

/**realm
 * 
 * 
 * 
 * @description Rest API call mixin for global use
 */
export default {
  name: 'RestMixin',
  methods: {
    // Generated an axios ajax request service for consistent use of calls to IDM or AM
    getRequestService(config) {
      let baseURL = idmContext;
      let timeout = 5000;
      let headers = {
        'content-type': 'application/json',
        'x-requested-with': 'XMLHttpRequest',
      };

      if (config) {
        switch (config.context) {
          case 'IDM':
            baseURL = idmContext;
            break;
          case 'AM':
            baseURL = amContext;
            break;
          default:
            config.context = 'IDM';
            baseURL = idmContext;
            break;
        }

        // Use Legacy API
        if (config.context === 'AM') {
          let amBase = `${amContext}/json/`;
          amBase = `${amContext}/json/realms/root/realms/${realm}`;

          // can force request to a realm by passing in config.realm, else use the store value
          // if (config.realm) {
          //   if (config.realm !== '/' && config.realm !== 'root') {
          //     amBase = `${amContext}/json/realms/root/realms/${config.realm}`;
          //   }
          // } else if (this.$store) {
          //   if (this.$store.state.realm && this.$store.state.realm !== '/' && this.$store.state.realm !== 'root') {
          //     amBase = `${amContext}/json/realms/root/realms/${this.$store.state.realm}`;
          //   }
          // }

          const requestDetails = {
            baseURL: amBase,
            headers: {
              'Content-type': 'application/json',
              'accept-api-version': config.apiVersion || 'protocol=2.1,resource=1.0',
            },
          };
          return axios.create(requestDetails);
        }

        if (config.baseURL) {
          // eslint-disable-next-line prefer-destructuring
          baseURL = config.baseURL;
        }

        if (config.timeout) {
          // eslint-disable-next-line prefer-destructuring
          timeout = config.timeout;
        }

        if (config.headers && !isEmpty(config.headers)) {
          // eslint-disable-next-line prefer-destructuring
          headers = config.headers;
        }
      }

      if (this.$store) {
        headers = extend(headers, this.$store.state.authHeaders || {});
      }
      const instance = axios.create({
        baseURL,
        timeout,
        headers,
      });

      instance.interceptors.response.use((response) => response, (error) => {
        if (error.response && error.response.data && error.response.data.code === 401) {
          this.$router.push({ name: 'Login' });

          return Promise.reject(error);
        } if (isUndefined(error.response)) {
          // In the case of critical error
          return Promise.reject(new Error(error.message));
        }
        return Promise.reject(error);
      });

      return instance;
    },
    // Headers used for oauth requests and selfservice
    getAnonymousHeaders() {
      return this.$store.state.authHeaders || {};
    },
  },
};
</script>
